setVideoData